import { Box } from "@mui/material";

export interface AppLayoutInnerWrapperMobileProps {
  children: React.ReactNode;
}

export function AppLayoutPageWrapperMobile(props: AppLayoutInnerWrapperMobileProps) {
  const { children } = props;

  return (
    <Box
      data-bottom-sheet-wrapper=""
      sx={{
        height: "100%",
        overflow: "hidden",
        // Nesting provider targets this attribute for background scale on drawer open
        willChange: "transform",
        transformOrigin: "center top",
        // React Router's Switch/Route render unstyled divs that break the
        // height:100% chain — force all direct div children to fill height.
        "& > div": { height: "100%", overflow: "hidden" },
      }}
    >
      {children}
    </Box>
  );
}
